/**
 * Recherche globale (ADR 0043, 2026-10-10), français, langue de référence. Branchée dans `fr.ts`
 * sous la clé `search` ; `search.en.ts` porte exactement les mêmes clés (typage + `i18n.test.ts`).
 */
export const searchFr = {
  title: 'Recherche',
  subtitle:
    'Projets, jobs, workflows, infrastructures, endpoints et catalogue de l’organisation. Seul ce que vous pouvez lire apparaît.',
  placeholder: 'Rechercher par nom ou description…',
  label: 'Termes recherchés',
  hint: 'Tous les mots sont exigés ; un début de mot suffit. Les secrets, identités et utilisateurs ne sont jamais cherchés.',
  prompt: 'Saisissez au moins un mot.',
  empty: {
    title: 'Aucun résultat',
    description: 'Rien de ce que vous pouvez lire ne correspond à « {{query}} ».',
  },
  count_one: '{{count}} résultat',
  count_other: '{{count}} résultats',
  columns: {
    type: 'Type',
    name: 'Nom',
    description: 'Description',
    updated: 'Modifié',
  },
  types: {
    project: 'Projet',
    job: 'Job',
    workflow: 'Workflow',
    infrastructure: 'Infrastructure',
    endpoint: 'Endpoint',
    catalog: 'Catalogue',
    database: 'Base',
    table: 'Table',
  },
  filter: 'Type',
} as const;
